import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Check from "@material-ui/icons/Check";
import InfoIcon from "@material-ui/icons/Info";
import PeopleIcon from "@material-ui/icons/People";
import PublicIcon from "@material-ui/icons/Public";
import SaveIcon from "@material-ui/icons/Save";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomTextarea from "components/CustomTextarea/CustomTextarea";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { OK } from "config/general/Configuracion";
import AplicarSeguridad from "conten/components/AplicarSeguridad";
import TituloPagina2 from "conten/components/TituloPagina2";
// module components
import WaitDialog from "conten/components/WaitDialog.jsx";
import {
  grabarCuenta, grabarLimitePlacaExenta, grabarLimiteMaxZonas,
  grabarLimiteMaxPerfilesAdministrador, grabarLimiteMaxPerfilesSupervisor,
  grabarLimiteMaxPerfilesAuxiliar, grabarLimiteMaxPerfilesMunicipio,
  grabarLimiteMaxPerfilesVisor, grabarLimiteMaxPerfilesPromotor
} from "conten/cuentas/CuentaActions";
import { addMessage } from "conten/mensajes/MessagesActions";
import React from "react";
import { connect } from "react-redux";

class CuentaAdministrar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textoAlerta: "Estamos procesando los datos :)",
      cuenta: {
        schema: "",
        nombre: "",
        informacion: "",
        activo: true,
      },
    };
  }

  componentDidMount = () => {
    var urlParams = new URLSearchParams(this.props.location.search);
    if (urlParams.has("editar")) {
      if (urlParams.get("editar") === "true") {
        if (this.props.location.state.cuenta) {
          this.setState({ cuenta: this.props.location.state.cuenta });
        }
      }
    }
  };

  abrirAlerta = (text, contenidoTipo = "error") => {
    this.props.addMessage({ variant: contenidoTipo, message: text + "" });
  };

  cambioContenidoCuenta = (valor, campo) => {
    var cuentaCambio = this.state.cuenta;
    cuentaCambio[campo] = valor;
    this.setState({ cuenta: cuentaCambio });
    return true;
  };

  validarContenidos = () => { };

  resultadoGrabar = (resultado) => {
    if (resultado === OK) {
      this.props.history.goBack();
    }
  };

  guardarCambios = () => {
    try {
      this.validarContenidos();
      const cuenta = this.state.cuenta;

      this.setState({ textoAlerta: "Guardando cuenta..." });

      this.props.grabarCuenta(cuenta, (resultado) => {
        if (resultado === OK) {
          const idCuenta = cuenta.id || cuenta.schema;

          const tareas = [];

          const agregarTarea = (condicion, accion) => {
            if (condicion !== undefined) {
              tareas.push(
                new Promise((resolve) => {
                  accion(resolve);
                })
              );
            }
          };

          // Limites a guardar
          agregarTarea(cuenta.max_placa_exenta, (resolve) =>
            this.props.grabarLimitePlacaExenta(idCuenta, cuenta.max_placa_exenta, () => {
              console.log("✅ max_placa_exenta guardado");
              resolve();
            })
          );

          agregarTarea(cuenta.max_zonas, (resolve) =>
            this.props.grabarLimiteMaxZonas(idCuenta, cuenta.max_zonas, () => {
              console.log("✅ max_zonas guardado");
              resolve();
            })
          );

          agregarTarea(cuenta.max_perfiles_administrador, (resolve) =>
            this.props.grabarLimiteMaxPerfilesAdministrador(idCuenta, cuenta.max_perfiles_administrador, () => {
              console.log("✅ max_perfiles_administrador guardado");
              resolve();
            })
          );

          agregarTarea(cuenta.max_perfiles_supervisor, (resolve) =>
            this.props.grabarLimiteMaxPerfilesSupervisor(idCuenta, cuenta.max_perfiles_supervisor, () => {
              console.log("✅ max_perfiles_supervisor guardado");
              resolve();
            })
          );

          agregarTarea(cuenta.max_perfiles_auxiliar, (resolve) =>
            this.props.grabarLimiteMaxPerfilesAuxiliar(idCuenta, cuenta.max_perfiles_auxiliar, () => {
              console.log("✅ max_perfiles_auxiliar guardado");
              resolve();
            })
          );

          agregarTarea(cuenta.max_perfiles_municipio, (resolve) =>
            this.props.grabarLimiteMaxPerfilesMunicipio(idCuenta, cuenta.max_perfiles_municipio, () => {
              console.log("✅ max_perfiles_municipio guardado");
              resolve();
            })
          );

          agregarTarea(cuenta.max_perfiles_visor, (resolve) =>
            this.props.grabarLimiteMaxPerfilesVisor(idCuenta, cuenta.max_perfiles_visor, () => {
              console.log("✅ max_perfiles_visor guardado");
              resolve();
            })
          );

          agregarTarea(cuenta.max_perfiles_promotor, (resolve) =>
            this.props.grabarLimiteMaxPerfilesPromotor(idCuenta, cuenta.max_perfiles_promotor, () => {
              console.log("✅ max_perfiles_promotor guardado");
              resolve();
            })
          );

          // Ejecutar todas las tareas en paralelo
          Promise.all(tareas).then(() => {
            this.resultadoGrabar(OK);
          });

        }
      });
    } catch (msg) {
      this.abrirAlerta(msg);
    }
  };


  render() {
    const { classes } = this.props;
    const { isActivityIndicatorShown } = this.props.cuentaState;
    return (
      <GridItem xs={12}>
        {isActivityIndicatorShown && (
          <WaitDialog text={this.state.textoAlerta} />
        )}
        <AplicarSeguridad />
        <Card>
          <CardHeader icon>
            <CardIcon
              style={{
                cursor: "pointer",
              }}
              color="primary"
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              <b>{"Ver listado"}</b>
              <PeopleIcon />
            </CardIcon>
            <TituloPagina2
              texto="Datos de cuenta"
              color="primary"
              classes={classes}
            />
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12}>
                <CustomInput
                  labelText="* Nombre"
                  id="etiquetaNombre"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "nombre",
                    id: "nombre",
                    value: this.state.cuenta.nombre,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "nombre"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={3} sm={3}>
                <CustomInput
                  labelText="* Maximo de placas exentas"
                  id="etiquetaMaximoPlacasExentas"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "max_placa_exenta",
                    id: "max_placa_exenta",
                    value: this.state.cuenta.max_placa_exenta,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "max_placa_exenta"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={3} sm={3}>
                <CustomInput
                  labelText="* Maximo de zonas"
                  id="etiquetaMaximoZonas"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "max_zonas",
                    id: "max_zonas",
                    value: this.state.cuenta.max_zonas,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "max_zonas"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={3} sm={3}>
                <CustomInput
                  labelText="* Maximo de perfiles administrador"
                  id="etiquetaMaximoPerfilesAdministrador"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "max_perfiles_administrador",
                    id: "max_perfiles_administrador",
                    value: this.state.cuenta.max_perfiles_administrador,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "max_perfiles_administrador"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={3} sm={3}>
                <CustomInput
                  labelText="* Maximo de perfiles supervisor"
                  id="etiquetaMaximoPerfilesSupervisor"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "max_perfiles_supervisor",
                    id: "max_perfiles_supervisor",
                    value: this.state.cuenta.max_perfiles_supervisor,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "max_perfiles_supervisor"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={3} sm={3}>
                <CustomInput
                  labelText="* Maximo de perfiles auxiliar"
                  id="etiquetaMaximoPerfilesAuxiliar"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "max_perfiles_auxiliar",
                    id: "max_perfiles_auxiliar",
                    value: this.state.cuenta.max_perfiles_auxiliar,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "max_perfiles_auxiliar"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={3} sm={3}>
                <CustomInput
                  labelText="* Maximo de perfiles municipio"
                  id="etiquetaMaximoPerfilesMunicipio"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "max_perfiles_municipio",
                    id: "max_perfiles_municipio",
                    value: this.state.cuenta.max_perfiles_municipio,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "max_perfiles_municipio"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={3} sm={3}>
                <CustomInput
                  labelText="* Maximo de perfiles visor"
                  id="etiquetaMaximoPerfilesVisor"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "max_perfiles_visor",
                    id: "max_perfiles_visor",
                    value: this.state.cuenta.max_perfiles_visor,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "max_perfiles_visor"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>
              <GridItem xs={3} sm={3}>
                <CustomInput
                  labelText="* Maximo de perfiles promotor"
                  id="etiquetaMaximoPerfilesPromotor"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    name: "max_perfiles_promotor",
                    id: "max_perfiles_promotor",
                    value: this.state.cuenta.max_perfiles_promotor,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(event.target.value, "max_perfiles_promotor"),
                    endAdornment: (
                      <InputAdornment position="start">
                        <PublicIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={12}>
                <CustomTextarea
                  labelText="Información"
                  id="informacion"
                  success
                  formControlProps={{
                    fullWidth: true,
                  }}
                  iconend={<InfoIcon />}
                  value={this.state.cuenta.informacion}
                  inputProps={{
                    value: this.state.cuenta.informacion,
                    onChange: (event) =>
                      this.cambioContenidoCuenta(
                        event.target.value,
                        "informacion"
                      ),
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked,
                      }}
                      checked={this.state.cuenta.activo}
                      onChange={() =>
                        this.cambioContenidoCuenta(
                          !this.state.cuenta.activo,
                          "activo"
                        )
                      }
                      disableRipple
                    />
                  }
                  label="Activa"
                ></FormControlLabel>
              </GridItem>

              <br />
              <GridItem xs={12} sm={12} className={classes.gridItem}>
                <Button
                  type="button"
                  onClick={(e) => {
                    this.guardarCambios();
                    e.preventDefault();
                  }}
                  color="success"
                >
                  <SaveIcon />
                  Guardar
                </Button>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cuentaState: state.cuentaState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addMessage: (content) => dispatch(addMessage(content)),
    grabarCuenta: (cuenta, onSuccess) =>
      dispatch(grabarCuenta(cuenta, onSuccess)),
    grabarLimitePlacaExenta: (cuenta, valor, onSuccess) =>
      dispatch(grabarLimitePlacaExenta(cuenta, valor, onSuccess)),
    grabarLimiteMaxZonas: (cuenta, valor, onSuccess) =>
      dispatch(grabarLimiteMaxZonas(cuenta, valor, onSuccess)),
    grabarLimiteMaxPerfilesAdministrador: (cuenta, valor, onSuccess) =>
      dispatch(grabarLimiteMaxPerfilesAdministrador(cuenta, valor, onSuccess)),
    grabarLimiteMaxPerfilesSupervisor: (cuenta, valor, onSuccess) =>
      dispatch(grabarLimiteMaxPerfilesSupervisor(cuenta, valor, onSuccess)),
    grabarLimiteMaxPerfilesAuxiliar: (cuenta, valor, onSuccess) =>
      dispatch(grabarLimiteMaxPerfilesAuxiliar(cuenta, valor, onSuccess)),
    grabarLimiteMaxPerfilesMunicipio: (cuenta, valor, onSuccess) =>
      dispatch(grabarLimiteMaxPerfilesMunicipio(cuenta, valor, onSuccess)),
    grabarLimiteMaxPerfilesVisor: (cuenta, valor, onSuccess) =>
      dispatch(grabarLimiteMaxPerfilesVisor(cuenta, valor, onSuccess)),
    grabarLimiteMaxPerfilesPromotor: (cuenta, valor, onSuccess) =>
      dispatch(grabarLimiteMaxPerfilesPromotor(cuenta, valor, onSuccess)),

  };

};

export default withStyles(extendedTablesStyle)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CuentaAdministrar)
);
